module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/cassette.png?2c0b4e4aaa2646cfef08f01aa4686312";